import React, { useState, useEffect, useRef } from 'react';
import { 
  Phone, MapPin, Clock, Utensils, Star, ChevronDown, Menu as MenuIcon, 
  X, Facebook, ExternalLink, Check, Quote, ArrowRight, Navigation
} from 'lucide-react';
import './App.css';
import restaurantImg from "./assets/restaurant.jpg";
import logoImg from "./assets/logo.jpg";
import meniu1 from "./assets/Meniu/1.jpg";
import meniu2 from "./assets/Meniu/2.jpg";
import meniu3 from "./assets/Meniu/3.jpg";
import meniu4 from "./assets/Meniu/4.jpg";
import meniu5 from "./assets/Meniu/5.jpg";
import meniu6 from "./assets/Meniu/6.jpg";
import meniu7 from "./assets/Meniu/7.jpg";
import meniu8 from "./assets/Meniu/8.jpg";

import mancare1 from "./assets/Mancare/1.jpg";
import mancare2 from "./assets/Mancare/2.jpg";
import mancare3 from "./assets/Mancare/3.jpg";
import mancare4 from "./assets/Mancare/4.jpg";
import mancare5 from "./assets/Mancare/5.jpg";
import mancare6 from "./assets/Mancare/6.jpg";
import mancare7 from "./assets/Mancare/7.jpg";
import mancare8 from "./assets/Mancare/8.jpg";
import mancare9 from "./assets/Mancare/9.jpg";
import mancare10 from "./assets/Mancare/10.jpg";
import mancare11 from "./assets/Mancare/11.jpg";
import mancare12 from "./assets/Mancare/12.jpg";

import atmosfera1 from "./assets/Atmosfera/1.jpg";
import atmosfera2 from "./assets/Atmosfera/2.jpg";
import atmosfera3 from "./assets/Atmosfera/3.jpg";

import bar1 from "./assets/Bar/1.jpg";
import bar2 from "./assets/Bar/2.jpg";
import bar3 from "./assets/Bar/3.jpg";
import bar4 from "./assets/Bar/4.jpg";
import bar5 from "./assets/Bar/5.jpg";
import bar6 from "./assets/Bar/6.jpg";
import bar7 from "./assets/Bar/7.jpg";




const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

// Restaurant Data (fallback)
const RESTAURANT_DATA = {
  name: "Grand Gurmand Restaurant",
  tagline: "Gust italian autentic într-o atmosferă modernă.",
  subtitle: "Restaurant italian în Orhei",
  rating: 4.8,
  reviewsCount: 83,
  phone: "+373 690 66 654",
  address: "Orhei MD, str. Vasile Mahu 152, MD-3505, B, Republica Moldova",
  plusCode: "9RGG+22 Orhei, Moldova",
  schedule: "Deschis • Închide la 23:00",
  services: ["Servicii luat masa", "La pachet"],
  facebook: "https://www.facebook.com/people/Grand-Gurmand-Restaurant/61573072011097/",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=9RGG%2B22+Orhei,+Moldova"
};

const MENU_DATA = {
  categories: ["Mic Dejun (10:00-12:30)", "Aperitive", "Salate", "Supe", "Bucate Tradiționale", "Plăcinte", "Pește & Carne", "Paste", "Garnituri", "Snack-uri", "Deserturi", "Adaosuri", "Cocktailuri", "Bere", "Spumant", "Vinuri Albe", "Vinuri Rosé", "Vinuri Roșii", "Băuturi Tari", "Băuturi Fierbinți", "Băuturi Răcoritoare", "Băuturi Non-Alcoolice"],
  items: [
    // Mic Dejun (10:00-12:30)
    { id: "1", category: "Mic Dejun (10:00-12:30)", name: "Mic dejun Englez", description: "Ou, bacon, cârnăcior, fasole, roșii, ciuperci, ciabatta", weight: "470g", price: "160 MDL" },
    { id: "2", category: "Mic Dejun (10:00-12:30)", name: "Shakshouka", description: "Ou, sos de roșii, ardei, ceapă, usturoi, verdeață, ciabatta", weight: "400g", price: "135 MDL" },
    { id: "3", category: "Mic Dejun (10:00-12:30)", name: "Terci cu fructe pe lapte/apă", description: "Lapte/apă, cereale, unt, fructe sezoniere", weight: "450g", price: "80/70 MDL" },
    { id: "4", category: "Mic Dejun (10:00-12:30)", name: "Iaurt cu Chia", description: "Iaurt, miere, musli, chia, fructe sezoniere", weight: "240g", price: "80 MDL" },
    
    // Aperitive
    { id: "5", category: "Aperitive", name: "Olive condimentate", description: "Olive, usturoi, condimente, ulei extra virgin", weight: "200g", price: "110 MDL" },
    { id: "6", category: "Aperitive", name: "Ardei cu cream cheese", description: "Ardei capia, brânză cremă, nuci", weight: "200g", price: "105 MDL" },
    { id: "7", category: "Aperitive", name: "Brie la cuptor", description: "Brie, miere, nuci, dulceață, anghinare, pară, ciabatta", weight: "340g", price: "215 MDL" },
    { id: "8", category: "Aperitive", name: "Carpaccio de vițel", description: "Carne de vițel, ulei, rucola, parmesan, balsamic, sos", weight: "200g", price: "185 MDL" },
    { id: "9", category: "Aperitive", name: "Carpaccio de somon", description: "Somon, rucola, philadelphia, capere, ulei", weight: "220g", price: "170 MDL" },
    { id: "10", category: "Aperitive", name: "Bruschete cu ardei", description: "Ciabatta, brânză feta, ardei, ceapă verde", weight: "170g", price: "70 MDL" },
    { id: "11", category: "Aperitive", name: "Bruschete cu prosciutto", description: "Ciabatta, pesto, prosciutto, roșie uscată, parmezan", weight: "130g", price: "95 MDL" },
    { id: "12", category: "Aperitive", name: "Bruschete cu somon", description: "Ciabatta, philadelphia, rucola, somon", weight: "140g", price: "90 MDL" },
    { id: "13", category: "Aperitive", name: "Bruschete asortate", description: "Bruschete cu ardei, somon, prosciutto", weight: "220g", price: "125 MDL" },
    { id: "14", category: "Aperitive", name: "Legume Doina", description: "Roșii, castraveți, ardei, brânză de oi, ceapă verde, verdețuri", weight: "380g", price: "125 MDL" },
    { id: "15", category: "Aperitive", name: "Platou la vin", description: "Parmezan, brie, dor blue, roșii uscate, fructe de sezon, nuci", weight: "340g", price: "275 MDL" },
    { id: "16", category: "Aperitive", name: "Antipasti XS", description: "Brescia, coppa, prosciutto, salam finocchiona, daniele, parmezan, asiago, dor blue, miere, nuci, grissini, fructe de sezon, anghinare, roșii uscate", weight: "570g", price: "480 MDL" },
    { id: "17", category: "Aperitive", name: "Antipasti XXL", description: "Brescia, coppa, prosciutto, salam finocchiona, daniele, parmezan, asiago, dor blue, miere, nuci, grissini, fructe de sezon, anghinare, roșii uscate", weight: "900g", price: "840 MDL" },
    
    // Salate
    { id: "18", category: "Salate", name: "Caprese", description: "Mozzarella, roșii, pesto, ulei, busuioc", weight: "230g", price: "145 MDL" },
    { id: "19", category: "Salate", name: "Shopski", description: "Roșii, castraveți, brânză de oi, măsline", weight: "250g", price: "80 MDL" },
    { id: "20", category: "Salate", name: "Grecească", description: "Roșii, castraveți, ardei, mix de salată, olive, brânză feta, ceapă", weight: "350g", price: "95 MDL" },
    { id: "21", category: "Salate", name: "Salată de roșii", description: "Roșii, verdeață, ceapă", weight: "150g", price: "40 MDL" },
    { id: "22", category: "Salate", name: "Caesar cu pui", description: "Mix de salată, iceberg, sos, roșii cherry, pesmeți, parmezan, ou, pui", weight: "340g", price: "130 MDL" },
    { id: "23", category: "Salate", name: "Caesar cu bacon", description: "Mix de salată, iceberg, sos, roșii cherry, pesmeți, parmezan, ou, bacon", weight: "340g", price: "160 MDL" },
    { id: "24", category: "Salate", name: "Caesar cu creveți", description: "Mix de salată, iceberg, sos, roșii cherry, pesmeți, parmezan, ou, creveți", weight: "330g", price: "170 MDL" },
    { id: "25", category: "Salate", name: "Salată cu ton", description: "Rucola, roșii, ou de prepeliță, ton, porumb, lămâie", weight: "360g", price: "199 MDL" },
    { id: "26", category: "Salate", name: "Salată cu prosciutto", description: "Mix de salată, prosciutto, roșii uscate, dressing, roșii cherry, parmezan, balsamic", weight: "240g", price: "149 MDL" },
    { id: "27", category: "Salate", name: "Salată cu creveți și avocado", description: "Mix de salată, creveți, avocado, olive, dressing, roșii cherry, parmezan, lămâie", weight: "275g", price: "210 MDL" },
    { id: "28", category: "Salate", name: "Burrata cu cherry confiate", description: "Burrata, pesto, roșii cherry confiate, rucola, semințe, ulei extra virgin", weight: "275g", price: "248 MDL" },
    { id: "29", category: "Salate", name: "Salată cu somon slab sărat", description: "Mix de salată, avocado, somon slab sărat, roșii cherry, măsline, parmezan", weight: "360g", price: "185 MDL" },
    
    // Supe
    { id: "30", category: "Supe", name: "Borș roșu", description: "Borș, carne de vită, slănină, pâine, smântână, usturoi, ardei", weight: "400/50g", price: "105 MDL" },
    { id: "31", category: "Supe", name: "Ciorbă cu fasole", description: "Ciorbă, costiță de porc, castraveți murați", weight: "350/50g", price: "79 MDL" },
    { id: "32", category: "Supe", name: "Supă cremă cu ciuperci", description: "Supă, ciuperci, pesmeți", weight: "250/30g", price: "67 MDL" },
    
    // Bucate Tradiționale
    { id: "33", category: "Bucate Tradiționale", name: "Zeamă de pui", description: "Bulion, carne de pui, legume, tăiței, verdeață, smântână", weight: "400/50g", price: "85 MDL" },
    { id: "34", category: "Bucate Tradiționale", name: "Platou cu murături", description: "Roșii, castraveți, pepene verde, varză murată, verdeață", weight: "720g", price: "155 MDL" },
    { id: "35", category: "Bucate Tradiționale", name: "Gustare Tradițională", description: "Slănină, castraveți cornișori, brânză de oi, ceapă, usturoi, pâine", weight: "460g", price: "135 MDL" },
    { id: "36", category: "Bucate Tradiționale", name: "Hering cu cartofi", description: "Scrumbie, cartofi fierți, ceapă roșie, praz, verdeață", weight: "550g", price: "125 MDL" },
    { id: "37", category: "Bucate Tradiționale", name: "Scrob cu jumeri", description: "Ou, jumeri, verdeață", weight: "150g", price: "75 MDL" },
    { id: "38", category: "Bucate Tradiționale", name: "Mămăligă cu tocană de pui", description: "Mămăligă, tocană, smântână, brânză de oi, scrob, ceapă verde", weight: "510g", price: "170 MDL" },
    { id: "39", category: "Bucate Tradiționale", name: "Mămăligă cu tocană de porc", description: "Mămăligă, tocană, smântână, brânză de oi, scrob, ceapă verde", weight: "510g", price: "180 MDL" },
    { id: "40", category: "Bucate Tradiționale", name: "Mămăligă cu tocană de vită", description: "Mămăligă, tocană, smântână, brânză de oi, scrob, ceapă verde", weight: "550g", price: "230 MDL" },
    { id: "41", category: "Bucate Tradiționale", name: "Salată din vinete cu br. de oi", description: "Vinete, brânză de oi, ardei capia, ceapă roșie, ciabatta", weight: "230g", price: "110 MDL" },
    
    // Plăcinte
    { id: "42", category: "Plăcinte", name: "Plăcintă cu cartof", description: "Aluat, umplutură de cartof", weight: "300g", price: "75 MDL" },
    { id: "43", category: "Plăcinte", name: "Plăcintă cu cartof & jumeri", description: "Aluat, umplutură de cartof și jumeri", weight: "310g", price: "75 MDL" },
    { id: "44", category: "Plăcinte", name: "Plăcintă cu cartof & br. de oi", description: "Aluat, umplutură de cartof și brânză de oi", weight: "310g", price: "75 MDL" },
    { id: "45", category: "Plăcinte", name: "Plăcintă cu brânză de vaci", description: "Aluat, umplutură de brânză de vaci", weight: "300g", price: "75 MDL" },
    { id: "46", category: "Plăcinte", name: "Plăcintă cu brânză & verdeață", description: "Aluat, umplutură de brânză și verdeață", weight: "300g", price: "75 MDL" },
    { id: "47", category: "Plăcinte", name: "Plăcintă cu vișină", description: "Aluat, umplutură de vișine", weight: "310g", price: "75 MDL" },
    
    // Pește & Carne
    { id: "48", category: "Pește & Carne", name: "Somon în sos de spanac", description: "Somon, sos cu spanac, parmezan", weight: "220g", price: "245 MDL" },
    { id: "49", category: "Pește & Carne", name: "Dorado cu cartofi striviți", description: "Dorado, cartofi striviți, roșii, măsline, verdeață", weight: "590g", price: "330 MDL" },
    { id: "50", category: "Pește & Carne", name: "Midii în sos alb", description: "Midii, sos alb, praz, roșii cherry, lămâie, ciabatta", weight: "300g", price: "275 MDL" },
    { id: "51", category: "Pește & Carne", name: "Midii în sos roșu", description: "Midii, praz, sos pomodoro, lămâie, ciabatta", weight: "300g", price: "275 MDL" },
    { id: "52", category: "Pește & Carne", name: "Creveți în sos Tequila", description: "Creveți, tequila, sos alb, verdeață, roșii cherry, lămâie, ciabatta", weight: "385g", price: "345 MDL" },
    { id: "53", category: "Pește & Carne", name: "Platou cu fructe de mare XS", description: "Dorado, somon, inele de calamar, baby calamar, creveți pane, creveți tequila, midii în sos roșu, tentacule de calamar, sos de usturoi, ciabatta + 1 sticlă spumant", weight: "2800g", price: "1750 MDL" },
    { id: "54", category: "Pește & Carne", name: "Platou cu fructe de mare XXL", description: "Dorado, somon, inele de calamar, baby calamar, creveți pane, creveți tequila, midii în sos roșu, tentacule de calamar, sos de usturoi, ciabatta + 1 sticlă spumant", weight: "5400g", price: "3500 MDL" },
    { id: "55", category: "Pește & Carne", name: "Piept de pui în sos de spanac", description: "Piept de pui, sos cu spanac, roșii uscate, olive grill", weight: "300g", price: "165 MDL" },
    { id: "56", category: "Pește & Carne", name: "Pulpă de rață cu mere caramelizate", description: "Pulpă de rață, gem de mure, mere caramelizate", weight: "230g", price: "210 MDL" },
    { id: "57", category: "Pește & Carne", name: "Ceafă de porc cu legume grill", description: "Ceafă de porc, dovlecel, vinete, ciuperci, ardei, adjică", weight: "330/50g", price: "195 MDL" },
    { id: "58", category: "Pește & Carne", name: "Costită de porc cu cartofi pai", description: "Costită de porc, sos BBQ, cartofi pai, castraveți cornișori, ceapă roșie, adjică", weight: "480/50g", price: "220 MDL" },
    { id: "59", category: "Pește & Carne", name: "Carne de vițel", description: "Carne de vițel, piure din cartof, sos din nuci", weight: "350g", price: "420 MDL" },
    { id: "60", category: "Pește & Carne", name: "File mignone", description: "Mușchi de vițel, sos 4 piper, cartofi pai chips, roșii cherry", weight: "385g", price: "485 MDL" },
    { id: "61", category: "Pește & Carne", name: "Platou cu carne XS", description: "Ceafă de porc, piept de pui, carne de vițel, costiță de porc, ardei, dovlecel, vânătă, ciuperci, roșii cherry, cartofi, adjică + 1 sticlă de vin roșu", weight: "1150g", price: "999 MDL" },
    { id: "62", category: "Pește & Carne", name: "Platou cu carne XXL", description: "Ceafă de porc, piept de pui, carne de vițel, costiță de porc, ardei, dovlecel, vânătă, ciuperci, roșii cherry, cartofi, adjică + 1 sticlă de vin roșu", weight: "2200g", price: "1799 MDL" },
    
    // Paste
    { id: "63", category: "Paste", name: "Spaghetti in Bianco", description: "Spaghete, unt, parmezan", weight: "230g", price: "85 MDL" },
    { id: "64", category: "Paste", name: "Spaghetti cu Pomodori", description: "Spaghete, sos pomodoro, parmezan, busuioc", weight: "300g", price: "120 MDL" },
    { id: "65", category: "Paste", name: "Pene 4 Formaggi", description: "Pene, gorgonzola, emmental, parmezan, mozzarella, unt, busuioc", weight: "300g", price: "185 MDL" },
    { id: "66", category: "Paste", name: "Spaghetti Carbonara", description: "Spaghete, guanciale, pancetta, pecorino, parmezan, ou", weight: "350g", price: "245 MDL" },
    { id: "67", category: "Paste", name: "Spaghetti Bolognese", description: "Spaghete, sos bolognese, parmezan, busuioc", weight: "350g", price: "125 MDL" },
    { id: "68", category: "Paste", name: "Spaghetti cu Ton", description: "Spaghete, ton, sos de pomodori, parmezan, usturoi", weight: "300g", price: "155 MDL" },
    { id: "69", category: "Paste", name: "Tagliatelle cu Creveți", description: "Tagliatelle, suc de lămâie, creveți, roșii cherry, usturoi, unt", weight: "330g", price: "180 MDL" },
    { id: "70", category: "Paste", name: "Tagliatelle cu Somon", description: "Tagliatelle, unt, somon, usturoi, frișcă", weight: "330g", price: "175 MDL" },
    { id: "71", category: "Paste", name: "Lasagna Bolognese", description: "Foi de lasagna, sos bolognese, mozzarella, sos", weight: "350g", price: "155 MDL" },
    
    // Garnituri
    { id: "72", category: "Garnituri", name: "Cartofi fierți", description: "Cartofi fierți", weight: "250g", price: "55 MDL" },
    { id: "73", category: "Garnituri", name: "Cartofi grilați", description: "Cartofi grilați", weight: "200g", price: "50 MDL" },
    { id: "74", category: "Garnituri", name: "Piure din cartof", description: "Piure cremos de cartofi", weight: "200g", price: "55 MDL" },
    { id: "75", category: "Garnituri", name: "Orez basmati", description: "Orez basmati fiert", weight: "180g", price: "45 MDL" },
    { id: "76", category: "Garnituri", name: "Legume la grătar", description: "Legume asortate la grătar", weight: "250g", price: "87 MDL" },
    { id: "77", category: "Garnituri", name: "Mămăligă cu brânză & smântână", description: "Mămăligă tradițională cu brânză și smântână", weight: "180/30/50g", price: "70 MDL" },
    
    // Snack-uri
    { id: "78", category: "Snack-uri", name: "Cartofi pai", description: "Cartofi pai crocanți cu sos la alegere", weight: "180/50g", price: "55 MDL" },
    { id: "79", category: "Snack-uri", name: "Cartofi bile", description: "Bile de cartofi prăjite", weight: "200/50g", price: "60 MDL" },
    { id: "80", category: "Snack-uri", name: "Mozzarella pane", description: "Mozzarella în crustă crocantă", weight: "200/50g", price: "120 MDL" },
    { id: "81", category: "Snack-uri", name: "Nuggets de pui", description: "Nuggets de pui crocanți", weight: "200/50g", price: "90 MDL" },
    { id: "82", category: "Snack-uri", name: "Creveți pane", description: "Creveți în crustă crocantă", weight: "170/50/25g", price: "185 MDL" },
    
    // Deserturi
    { id: "83", category: "Deserturi", name: "Înghețată vanilie/ciocolată", description: "Înghețată cu topping: ciocolată/caramelă/fructe de pădure, fructe de sezon", weight: "150/30/20g", price: "55 MDL" },
    { id: "84", category: "Deserturi", name: "Tiramisu", description: "Tiramisu, cacao, mentă", weight: "200g", price: "80 MDL" },
    { id: "85", category: "Deserturi", name: "Creme Brulee", description: "Creme brulee, zahăr brun topit, mentă", weight: "100g", price: "50 MDL" },
    { id: "86", category: "Deserturi", name: "Fondant din ciocolată", description: "Fondant din ciocolată, înghețată, gem din mure, fructe de sezon", weight: "100/50/20g", price: "135 MDL" },
    { id: "87", category: "Deserturi", name: "Cheesecake San Sebastian", description: "Cheesecake, ciocolată topită, fructe de sezon", weight: "150/50g", price: "95 MDL" },
    { id: "88", category: "Deserturi", name: "Mulii cu brânză dulce", description: "Clătite, brânză, zahăr pudră, smântână dulce", weight: "180/50g", price: "75 MDL" },
    
    // Adaosuri
    { id: "89", category: "Adaosuri", name: "Chiflă albă/sură", description: "Pâine proaspătă", weight: "60g", price: "7 MDL" },
    { id: "90", category: "Adaosuri", name: "Ciabatta", description: "Pâine italiană ciabatta", weight: "50g", price: "7 MDL" },
    { id: "91", category: "Adaosuri", name: "Coș cu pâine", description: "Coș asortat cu pâine", weight: "265g", price: "38 MDL" },
    { id: "92", category: "Adaosuri", name: "Smântână", description: "Smântână proaspătă", weight: "50g", price: "13 MDL" },
    { id: "93", category: "Adaosuri", name: "Maioneză", description: "Maioneză de casă", weight: "50g", price: "12 MDL" },
    { id: "94", category: "Adaosuri", name: "Ketchup", description: "Ketchup", weight: "50g", price: "12 MDL" },
    { id: "95", category: "Adaosuri", name: "Sos din usturoi", description: "Sos cremos de usturoi", weight: "50g", price: "15 MDL" },
    { id: "96", category: "Adaosuri", name: "Sos Caesar", description: "Sos Caesar clasic", weight: "50g", price: "20 MDL" },
    { id: "97", category: "Adaosuri", name: "Adjică", description: "Adjică picantă", weight: "50g", price: "20 MDL" },
    { id: "98", category: "Adaosuri", name: "Ardei iute", description: "Ardei iute", weight: "30g", price: "15 MDL" },
    { id: "99", category: "Adaosuri", name: "Usturoi", description: "Usturoi", weight: "30g", price: "10 MDL" },
    { id: "100", category: "Adaosuri", name: "Ceapă", description: "Ceapă", weight: "30g", price: "5 MDL" },
    { id: "101", category: "Adaosuri", name: "Brânză de oi", description: "Brânză de oi", weight: "50g", price: "30 MDL" },
    { id: "102", category: "Adaosuri", name: "Parmezan", description: "Parmezan italian", weight: "30g", price: "35 MDL" },
    { id: "103", category: "Adaosuri", name: "Pecorino", description: "Brânză pecorino", weight: "30g", price: "40 MDL" },
    { id: "104", category: "Adaosuri", name: "Slănină", description: "Slănină", weight: "50g", price: "25 MDL" },
    { id: "105", category: "Adaosuri", name: "Castraveți murați", description: "Castraveți murați", weight: "100g", price: "20 MDL" },
    { id: "106", category: "Adaosuri", name: "Anghinare", description: "Anghinare marinată", weight: "70g", price: "35 MDL" },
    { id: "107", category: "Adaosuri", name: "Nuci", description: "Nuci", weight: "30g", price: "30 MDL" },
    { id: "108", category: "Adaosuri", name: "Miere", description: "Miere naturală", weight: "50g", price: "25 MDL" },
    
    // Cocktailuri
    { id: "109", category: "Cocktailuri", name: "Negroni", description: "Campari, red dry vermouth, gin", weight: "250ml", price: "120 MDL" },
    { id: "110", category: "Cocktailuri", name: "Aperol Spritz", description: "Aperol, prosecco, apă gazoasă", weight: "300ml", price: "110 MDL" },
    { id: "111", category: "Cocktailuri", name: "Campari Spritz", description: "Campari, prosecco, apă gazoasă", weight: "300ml", price: "130 MDL" },
    { id: "112", category: "Cocktailuri", name: "Mojito", description: "Lime, zahăr brun, mojito sirop, rum, apă gazată", weight: "300ml", price: "115 MDL" },
    { id: "113", category: "Cocktailuri", name: "Pina Colada", description: "Cocos sirop, fulgi de cocos, lapte vegan, frișcă, suc ananas", weight: "250ml", price: "125 MDL" },
    { id: "114", category: "Cocktailuri", name: "Gin & Tonic", description: "Lime, gin, tonic", weight: "200ml", price: "95 MDL" },
    { id: "115", category: "Cocktailuri", name: "Margarita", description: "Lime, sare, cointreau, triple sec, tequila", weight: "100ml", price: "85 MDL" },
    { id: "116", category: "Cocktailuri", name: "Coronarita", description: "Corona, tequila, lychee, triple sec", weight: "410ml", price: "210 MDL" },
    { id: "117", category: "Cocktailuri", name: "Long Island", description: "Vodcă, tequila, triple sec, rum, gin, sirop de zahăr, suc lămâie, cola", weight: "200ml", price: "230 MDL" },
    { id: "118", category: "Cocktailuri", name: "Porn Star Martini", description: "Vodcă, liquor, piure fructul pasiunii, prosecco", weight: "210ml", price: "120 MDL" },
    { id: "119", category: "Cocktailuri", name: "Pumpkin Espresso Martini", description: "Coffee, pumpkin, vodcă, liquor", weight: "130ml", price: "105 MDL" },
    
    // Bere
    { id: "120", category: "Bere", name: "Birra Moretti", description: "Bere italiană clasică", weight: "330ml", price: "45 MDL" },
    { id: "121", category: "Bere", name: "Birra Moretti Non-Alc", description: "Bere italiană fără alcool", weight: "330ml", price: "45 MDL" },
    { id: "122", category: "Bere", name: "Heineken", description: "Bere olandeză premium", weight: "330ml", price: "60 MDL" },
    { id: "123", category: "Bere", name: "Corona Extra", description: "Bere mexicană", weight: "355ml", price: "70 MDL" },
    { id: "124", category: "Bere", name: "Blanc 1664", description: "Bere franceză albă", weight: "460ml", price: "72 MDL" },
    
    // Spumant
    { id: "125", category: "Spumant", name: "Dolce Vio Corten", description: "Demisec", weight: "750ml", price: "160 MDL" },
    { id: "126", category: "Spumant", name: "D'Oro Corten", description: "Brut", weight: "750ml", price: "180 MDL" },
    { id: "127", category: "Spumant", name: "Muscat Aurelius", description: "Dulce", weight: "750ml", price: "350 MDL" },
    { id: "128", category: "Spumant", name: "Glera Aurelius", description: "Brut", weight: "750ml", price: "350 MDL" },
    { id: "129", category: "Spumant", name: "Fetească Regală Aurelius", description: "Brut", weight: "750ml", price: "350 MDL" },
    { id: "130", category: "Spumant", name: "Ice Wine Aurelius", description: "Dulce", weight: "375ml", price: "850 MDL" },
    { id: "131", category: "Spumant", name: "Mini Prosecco Millesimato Maestro", description: "Extra sec", weight: "200ml", price: "120 MDL" },
    { id: "132", category: "Spumant", name: "Muscat Maestro", description: "Dulce", weight: "750ml", price: "360 MDL" },
    { id: "133", category: "Spumant", name: "Rosé Maestro", description: "Dulce", weight: "750ml", price: "360 MDL" },
    { id: "134", category: "Spumant", name: "Cuvee Blanc Maestro", description: "Brut", weight: "750ml", price: "360 MDL" },
    { id: "219", category: "Spumant", name: "Citron Maestro", description: "Brut", weight: "750ml", price: "380 MDL" },
    { id: "135", category: "Spumant", name: "Prosecco Millesimato DOC Maestro", description: "Extra sec", weight: "750ml", price: "380 MDL" },
    { id: "136", category: "Spumant", name: "Prosecco Valdobbiadene DOCG Maestro", description: "Brut", weight: "750ml", price: "400 MDL" },
    
    // Vinuri Albe
    { id: "137", category: "Vinuri Albe", name: "Viorica Corten", description: "Alb sec", weight: "750ml", price: "160 MDL" },
    { id: "138", category: "Vinuri Albe", name: "Pinot Gris Corten", description: "Alb sec", weight: "750ml", price: "160 MDL" },
    { id: "139", category: "Vinuri Albe", name: "Riesling Corten", description: "Alb sec", weight: "750ml", price: "160 MDL" },
    { id: "140", category: "Vinuri Albe", name: "Viorica Aurelius", description: "Alb sec", weight: "750ml", price: "240 MDL" },
    { id: "141", category: "Vinuri Albe", name: "Chardonnay Aurelius", description: "Alb sec", weight: "750ml", price: "240 MDL" },
    { id: "142", category: "Vinuri Albe", name: "Viorica Maestro", description: "Alb sec", weight: "750ml", price: "300 MDL" },
    { id: "143", category: "Vinuri Albe", name: "Fetească Regală Maestro", description: "Alb sec", weight: "750ml", price: "300 MDL" },
    { id: "220", category: "Vinuri Albe", name: "Blanc de Noir Merlot Maestro", description: "Alb sec", weight: "750ml", price: "300 MDL" },
    { id: "144", category: "Vinuri Albe", name: "Viorica (pahar)", description: "Alb sec", weight: "125ml", price: "30 MDL" },
    
    // Vinuri Rosé
    { id: "145", category: "Vinuri Rosé", name: "Pinot Noir Aurelius", description: "Rosé sec", weight: "750ml", price: "240 MDL" },
    { id: "146", category: "Vinuri Rosé", name: "Pinot Noir Maestro", description: "Rosé sec", weight: "750ml", price: "300 MDL" },
    { id: "147", category: "Vinuri Rosé", name: "Rosé (pahar)", description: "Rosé sec", weight: "125ml", price: "30 MDL" },
    
    // Vinuri Roșii
    { id: "148", category: "Vinuri Roșii", name: "Cabernet Franc Corten", description: "Roșu sec", weight: "750ml", price: "240 MDL" },
    { id: "149", category: "Vinuri Roșii", name: "Fetească Neagră Corten", description: "Roșu sec", weight: "750ml", price: "240 MDL" },
    { id: "150", category: "Vinuri Roșii", name: "Fetească Neagră & Saperavi Corten", description: "Roșu sec", weight: "750ml", price: "260 MDL" },
    { id: "151", category: "Vinuri Roșii", name: "Merlot Aurelius", description: "Roșu sec", weight: "750ml", price: "270 MDL" },
    { id: "152", category: "Vinuri Roșii", name: "Cab.Sauv.&Mer.&\nFet.Neag.Aurelius", description: "Roșu sec", weight: "750ml", price: "270 MDL" },
    { id: "153", category: "Vinuri Roșii", name: "Fetească Neagră&Rară Neag. Maestro", description: "Roșu sec", weight: "750ml", price: "300 MDL" },
    { id: "154", category: "Vinuri Roșii", name: "Secret Blend Maestro", description: "Roșu sec", weight: "750ml", price: "520 MDL" },
    { id: "221", category: "Vinuri Roșii", name: "4 în Roșu Maestro", description: "Roșu sec", weight: "750ml", price: "520 MDL" },
    { id: "155", category: "Vinuri Roșii", name: "Fetească Neagră (pahar)", description: "Roșu sec", weight: "125ml", price: "35 MDL" },
    
    // Băuturi Tari
    { id: "156", category: "Băuturi Tari", name: "Chateau Vartely Rachiu din Prune", description: "Rachiu tradițional", weight: "50ml", price: "35 MDL" },
    { id: "157", category: "Băuturi Tari", name: "Chateau Vartely Rachia di Moscato", description: "", weight: "50ml", price: "35 MDL" },
    { id: "158", category: "Băuturi Tari", name: "Tezaur Grappa din pepene galben", description: "", weight: "50ml", price: "30 MDL" },
    { id: "159", category: "Băuturi Tari", name: "Tezaur Grappa din prună", description: "", weight: "50ml", price: "30 MDL" },
    { id: "160", category: "Băuturi Tari", name: "Absolut Vodca", description: "Vodcă premium", weight: "50ml", price: "40 MDL" },
    { id: "161", category: "Băuturi Tari", name: "Finlandia Vodca", description: "Vodcă finlandeză", weight: "50ml", price: "30 MDL" },
    { id: "162", category: "Băuturi Tari", name: "SKYY Vodca", description: "Vodcă americană", weight: "50ml", price: "30 MDL" },
    { id: "163", category: "Băuturi Tari", name: "Hennesy VS de 3 ani", description: "Cognac francez", weight: "50ml", price: "110 MDL" },
    { id: "164", category: "Băuturi Tari", name: "Chateau Vartely VSOP de 5 ani", description: "Divin moldovenesc", weight: "50ml", price: "25 MDL" },
    { id: "165", category: "Băuturi Tari", name: "Chateau Vartely Tribut XO de 7 ani", description: "", weight: "50ml", price: "55 MDL" },
    { id: "166", category: "Băuturi Tari", name: "Maestro XO Rezerva de 10 ani", description: "Divin premium", weight: "50ml", price: "70 MDL" },
    { id: "167", category: "Băuturi Tari", name: "Maestro XO Signature de 10 ani", description: "Divin premium", weight: "50ml", price: "120 MDL" },
    { id: "168", category: "Băuturi Tari", name: "Maestro XXO Rezerva de 20 ani", description: "Divin premium", weight: "50ml", price: "185 MDL" },
    { id: "169", category: "Băuturi Tari", name: "Bacardi Carta Blanca", description: "Rom alb", weight: "50ml", price: "45 MDL" },
    { id: "170", category: "Băuturi Tari", name: "Bacardi Carta Negra", description: "Rom închis", weight: "50ml", price: "45 MDL" },
    { id: "171", category: "Băuturi Tari", name: "Captain Morgan Spice Gold", description: "Rom aromat", weight: "50ml", price: "45 MDL" },
    { id: "172", category: "Băuturi Tari", name: "Tequila Mexicano Bianco", description: "Tequila albă", weight: "50ml", price: "45 MDL" },
    { id: "173", category: "Băuturi Tari", name: "Jameson", description: "Whiskey irlandez", weight: "50ml", price: "50 MDL" },
    { id: "174", category: "Băuturi Tari", name: "Jack Daniel's", description: "Bourbon american", weight: "50ml", price: "55 MDL" },
    { id: "175", category: "Băuturi Tari", name: "Jim Beam", description: "Bourbon", weight: "50ml", price: "50 MDL" },
    { id: "176", category: "Băuturi Tari", name: "Chivas Regal", description: "Scotch whisky", weight: "50ml", price: "95 MDL" },
    { id: "177", category: "Băuturi Tari", name: "Bombay Sapphire", description: "Gin premium", weight: "50ml", price: "60 MDL" },
    { id: "178", category: "Băuturi Tari", name: "Beefeater Gin", description: "Gin englezesc", weight: "50ml", price: "45 MDL" },
    { id: "179", category: "Băuturi Tari", name: "Limoncello Madruzzo", description: "Lichior italian", weight: "50ml", price: "25 MDL" },
    { id: "180", category: "Băuturi Tari", name: "Aperol", description: "Aperitiv italian", weight: "50ml", price: "35 MDL" },
    { id: "181", category: "Băuturi Tari", name: "Campari", description: "Aperitiv italian", weight: "50ml", price: "40 MDL" },
    { id: "182", category: "Băuturi Tari", name: "Jägermeister", description: "Lichior german", weight: "50ml", price: "40 MDL" },
    { id: "183", category: "Băuturi Tari", name: "Cointreau", description: "Lichior de portocale", weight: "50ml", price: "50 MDL" },
    { id: "184", category: "Băuturi Tari", name: "Kahlua", description: "Lichior de cafea", weight: "50ml", price: "55 MDL" },
    { id: "185", category: "Băuturi Tari", name: "Bailey's", description: "Lichior de cremă", weight: "50ml", price: "50 MDL" },
    { id: "186", category: "Băuturi Tari", name: "Malibu", description: "Lichior de cocos", weight: "50ml", price: "45 MDL" },
    { id: "187", category: "Băuturi Tari", name: "Martini Bianco", description: "Vermut italian", weight: "50ml", price: "30 MDL" },
    { id: "188", category: "Băuturi Tari", name: "Martini Rossato", description: "Vermut italian", weight: "50ml", price: "30 MDL" },
    { id: "189", category: "Băuturi Tari", name: "Martini Rosso", description: "Vermut italian", weight: "50ml", price: "30 MDL" },
    
    // Băuturi Fierbinți
    { id: "190", category: "Băuturi Fierbinți", name: "Espresso", description: "Cafea espresso", weight: "30ml", price: "30 MDL" },
    { id: "191", category: "Băuturi Fierbinți", name: "Espresso Dublu", description: "Cafea espresso dublă", weight: "60ml", price: "45 MDL" },
    { id: "192", category: "Băuturi Fierbinți", name: "Americano", description: "Cafea americano", weight: "80ml", price: "30 MDL" },
    { id: "193", category: "Băuturi Fierbinți", name: "Cappuccino", description: "Cafea cu spumă de lapte", weight: "180ml", price: "40 MDL" },
    { id: "194", category: "Băuturi Fierbinți", name: "Cappuccino Vegan", description: "Cafea cu lapte vegetal", weight: "180ml", price: "50 MDL" },
    { id: "195", category: "Băuturi Fierbinți", name: "Latte", description: "Cafea latte", weight: "250ml", price: "50 MDL" },
    { id: "196", category: "Băuturi Fierbinți", name: "Latte Vegan", description: "Cafea latte cu lapte vegetal", weight: "250ml", price: "60 MDL" },
    { id: "197", category: "Băuturi Fierbinți", name: "Raff Coffee", description: "Cafea raff", weight: "250ml", price: "55 MDL" },
    { id: "198", category: "Băuturi Fierbinți", name: "Ceai infuzie", description: "Fructat, Mango, Nirvana, Negru, Jasmin", weight: "600ml", price: "55 MDL" },
    { id: "199", category: "Băuturi Fierbinți", name: "Ceai cătină/coacăză", description: "", weight: "600ml", price: "75 MDL" },
    
    // Băuturi Răcoritoare
    { id: "200", category: "Băuturi Răcoritoare", name: "Suc în asortiment", description: "Sucuri naturale", weight: "250ml", price: "25 MDL" },
    { id: "201", category: "Băuturi Răcoritoare", name: "Cappy Kids", description: "Măr-pară, multifruct, mure, banană-căpșună, măr-struguri", weight: "200ml", price: "20 MDL" },
    { id: "202", category: "Băuturi Răcoritoare", name: "RedBull", description: "Băutură energizantă", weight: "250ml", price: "55 MDL" },
    { id: "203", category: "Băuturi Răcoritoare", name: "Dorna plată", description: "Apă minerală", weight: "330ml", price: "32 MDL" },
    { id: "204", category: "Băuturi Răcoritoare", name: "Dorna plată mare", description: "Apă minerală", weight: "750ml", price: "48 MDL" },
    { id: "205", category: "Băuturi Răcoritoare", name: "Dorna gazoasă", description: "Apă minerală gazoasă", weight: "330ml", price: "32 MDL" },
    { id: "206", category: "Băuturi Răcoritoare", name: "Dorna gazoasă mare", description: "Apă minerală gazoasă", weight: "750ml", price: "48 MDL" },
    { id: "207", category: "Băuturi Răcoritoare", name: "Borjomi", description: "Apă minerală georgiană", weight: "330ml", price: "50 MDL" },
    { id: "208", category: "Băuturi Răcoritoare", name: "Borjomi mare", description: "Apă minerală georgiană", weight: "500ml", price: "65 MDL" },
    { id: "209", category: "Băuturi Răcoritoare", name: "Sprite", description: "Băutură răcoritoare", weight: "250ml", price: "25 MDL" },
    { id: "210", category: "Băuturi Răcoritoare", name: "Fanta", description: "Băutură răcoritoare", weight: "250ml", price: "25 MDL" },
    { id: "211", category: "Băuturi Răcoritoare", name: "Coca Cola", description: "Băutură răcoritoare", weight: "250ml", price: "25 MDL" },
    { id: "212", category: "Băuturi Răcoritoare", name: "Coca Cola Zero", description: "Băutură răcoritoare fără zahăr", weight: "250ml", price: "25 MDL" },
    
    // Băuturi Non-Alcoolice
    { id: "213", category: "Băuturi Non-Alcoolice", name: "Ice Tea", description: "Rodie, pepene verde/galben, matcha, banana, piersic", weight: "300ml", price: "75 MDL" },
    { id: "214", category: "Băuturi Non-Alcoolice", name: "Limonadă", description: "Clasică, lychee, căpșună, kiwi, fructul pasiunii, afine", weight: "250ml", price: "85 MDL" },
    { id: "215", category: "Băuturi Non-Alcoolice", name: "Ice Latte", description: "Caramelă, caramelă sărată, ciocolată, alune, cioc.biscuit, cocos", weight: "250ml", price: "65 MDL" },
    { id: "216", category: "Băuturi Non-Alcoolice", name: "Espresso Mojito", description: "", weight: "250ml", price: "100 MDL" },
    { id: "217", category: "Băuturi Non-Alcoolice", name: "Mojito (non-alc)", description: "Mojito fără alcool", weight: "250ml", price: "95 MDL" },
    { id: "218", category: "Băuturi Non-Alcoolice", name: "Pina Colada (non-alc)", description: "Pina Colada fără alcool", weight: "250ml", price: "105 MDL" },
  ]
};

const REVIEWS_DATA = [
  { id: "1", author: "Maria C.", rating: 5, text: "Personal foarte prietenos și amabil. Am fost impresionată de atenția acordată fiecărui client. Recomand cu căldură!", date: "2024-11-15" },
  { id: "2", author: "Ion P.", rating: 5, text: "Restaurant modern și extrem de curat. Atenția la detalii este remarcabilă - de la veselă până la decor. O experiență premium!", date: "2024-11-10" },
  { id: "3", author: "Elena D.", rating: 5, text: "Atmosferă plăcută și relaxantă. Mâncarea a depășit toate așteptările - preparate autentice italiene, gătite cu măiestrie.", date: "2024-11-05" },
  { id: "4", author: "Andrei M.", rating: 5, text: "Servire promptă și profesionistă. Pasta Carbonara a fost pur și simplu perfectă. Vom reveni cu siguranță!", date: "2024-10-28" },
  { id: "5", author: "Cristina L.", rating: 4, text: "Loc minunat pentru o cină romantică. Ambianța este elegantă fără a fi pretențioasă. Pizza foarte gustoasă!", date: "2024-10-20" },
];

const GALLERY_DATA = [
  // { id: 1, category: "Mâncăruri & băuturi", title: "Pasta Carbonara", image: "https://images.unsplash.com/photo-1612874742237-6526221588e3?w=600&q=80" },
  // { id: 2, category: "Atmosferă", title: "Interior Restaurant", image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=600&q=80" },
  // { id: 3, category: "Mâncăruri & băuturi", title: "Pizza Margherita", image: "https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=600&q=80" },
  // { id: 4, category: "Bar", title: "Bar & Lounge", image: "https://images.unsplash.com/photo-1470337458703-46ad1756a187?w=600&q=80" },
  // { id: 5, category: "Atmosferă", title: "Seară la Restaurant", image: "https://images.unsplash.com/photo-1550966871-3ed3cdb5ed0c?w=600&q=80" },
  // { id: 6, category: "Mâncăruri & băuturi", title: "Tiramisù", image: "https://images.unsplash.com/photo-1571877227200-a0d98ea607e9?w=600&q=80" },
  { id: 7, category: "Meniu", title: "Meniu", image: meniu1 },
  { id: 8, category: "Meniu", title: "Meniu", image: meniu2 },
  { id: 9, category: "Meniu", title: "Meniu", image: meniu3 },
  { id: 10, category: "Meniu", title: "Meniu", image: meniu4 },
  { id: 11, category: "Meniu", title: "Meniu", image: meniu5 },
  { id: 12, category: "Meniu", title: "Meniu", image: meniu6 },
  { id: 13, category: "Meniu", title: "Meniu", image: meniu7 },
  { id: 14, category: "Meniu", title: "Meniu", image: meniu8 },
  { id: 16, category: "Mâncăruri & băuturi", title: "Mâncare", image: mancare1 },
  { id: 17, category: "Mâncăruri & băuturi", title: "Mâncare", image: mancare2 },
  { id: 18, category: "Mâncăruri & băuturi", title: "Mâncare", image: mancare3 },
  { id: 19, category: "Mâncăruri & băuturi", title: "Mâncare", image: mancare4 },
  { id: 20, category: "Mâncăruri & băuturi", title: "Mâncare", image: mancare5 },
  { id: 21, category: "Mâncăruri & băuturi", title: "Mâncare", image: mancare6 },
  { id: 22, category: "Mâncăruri & băuturi", title: "Mâncare", image: mancare7 },
  { id: 23, category: "Mâncăruri & băuturi", title: "Mâncare", image: mancare8 },
  { id: 24, category: "Mâncăruri & băuturi", title: "Mâncare", image: mancare9 },
  { id: 25, category: "Mâncăruri & băuturi", title: "Mâncare", image: mancare10 },
  { id: 26, category: "Mâncăruri & băuturi", title: "Mâncare", image: mancare11 },
  { id: 27, category: "Mâncăruri & băuturi", title: "Mâncare", image: mancare12 },
  { id: 28, category: "Atmosferă", title: "Atmosferă", image: atmosfera1 },
  { id: 29, category: "Atmosferă", title: "Atmosferă", image: atmosfera2 },
  { id: 30, category: "Atmosferă", title: "Atmosferă", image: atmosfera3 },
  { id: 31, category: "Bar", title: "Bar", image: bar1 },
  { id: 32, category: "Bar", title: "Bar", image: bar2 },
  { id: 33, category: "Bar", title: "Bar", image: bar3 },
  { id: 34, category: "Bar", title: "Bar", image: bar4 },
  { id: 35, category: "Bar", title: "Bar", image: bar5 },
  { id: 36, category: "Bar", title: "Bar", image: bar6 },
  { id: 37, category: "Bar", title: "Bar", image: bar7 },

  // { id: 100, category: "Bar", title: "Vinuri Italiene", image: "https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?w=600&q=80" },
];

// Header Component
const Header = ({ scrolled, mobileMenuOpen, setMobileMenuOpen }) => {
  const navLinks = [
    { name: "Acasă", href: "#acasa" },
    { name: "Despre", href: "#despre" },
    { name: "Meniu", href: "#meniu" },
    { name: "Galerie", href: "#galerie" },
    { name: "Recenzii", href: "#recenzii" },
    { name: "Contact", href: "#contact" },
  ];

  return (
    <>
      <header 
        data-testid="header"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'header-scrolled py-3' : 'bg-transparent py-5'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <a href="#acasa" className="flex items-center gap-2" data-testid="logo">
              <span className={`font-display text-xl sm:text-2xl font-bold ${scrolled ? 'text-[#8B0000]' : 'text-white'}`}>
              <img
                src={logoImg}
                alt="Grand Gurmand Restaurant"
                className="h-23 w-20 rounded-lg object-cover"
              />
              </span>
            </a>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-8" data-testid="nav-desktop">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className={`font-medium transition-colors hover:text-[#C9A227] ${
                    scrolled ? 'text-gray-700' : 'text-white/90'
                  }`}
                >
                  {link.name}
                </a>
              ))}
            </nav>

            {/* CTA Button */}
            <div className="hidden sm:flex items-center gap-4">
              <a
                href={`tel:${RESTAURANT_DATA.phone.replace(/\s/g, '')}`}
                className="btn-primary animate-pulse-glow"
                data-testid="cta-call-header"
              >
                <Phone size={18} />
                <span className="hidden md:inline">Sună acum</span>
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden p-2"
              onClick={() => setMobileMenuOpen(true)}
              data-testid="mobile-menu-btn"
            >
              <MenuIcon size={28} className={scrolled ? 'text-gray-800' : 'text-white'} />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <div 
        className={`mobile-menu-overlay ${mobileMenuOpen ? 'open' : ''}`}
        onClick={() => setMobileMenuOpen(false)}
      />

      {/* Mobile Menu */}
      <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`} data-testid="mobile-menu">
        <button
          className="absolute top-6 right-6 p-2"
          onClick={() => setMobileMenuOpen(false)}
        >
          <X size={28} className="text-gray-800" />
        </button>

        <nav className="flex flex-col gap-6">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className="text-xl font-medium text-gray-800 hover:text-[#8B0000] transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.name}
            </a>
          ))}
          <a
            href={`tel:${RESTAURANT_DATA.phone.replace(/\s/g, '')}`}
            className="btn-primary mt-4 justify-center"
            data-testid="cta-call-mobile"
          >
            <Phone size={18} />
            Sună acum
          </a>
        </nav>
      </div>
    </>
  );
};

// Hero Section
const HeroSection = () => {
  return (
    <section 
      id="acasa" 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1920&q=80"
          alt="Restaurant Italian"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 gradient-overlay" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        <div className="animate-fade-in-up">
          {/* Rating Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <Star className="text-[#C9A227] fill-[#C9A227]" size={18} />
            <span className="text-white font-medium">
              {RESTAURANT_DATA.rating} din {RESTAURANT_DATA.reviewsCount} recenzii
            </span>
          </div>

          {/* Main Title */}
          <h1 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            {RESTAURANT_DATA.tagline}
          </h1>

          {/* Subtitle */}
          <p className="text-white/80 text-lg sm:text-xl mb-4">
            {RESTAURANT_DATA.subtitle} • <Star className="inline text-[#C9A227] fill-[#C9A227]" size={16} /> {RESTAURANT_DATA.rating} din {RESTAURANT_DATA.reviewsCount} recenzii
          </p>

          {/* Schedule */}
          <div className="inline-flex items-center gap-2 text-white/90 mb-8">
            <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
            <span>{RESTAURANT_DATA.schedule}</span>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={`tel:${RESTAURANT_DATA.phone.replace(/\s/g, '')}`}
              className="btn-white"
              data-testid="hero-cta-call"
            >
              <Phone size={20} />
              Rezervă prin telefon
            </a>
            <a
              href="#meniu"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full font-semibold transition-all duration-300 border-2 border-white text-white hover:bg-white hover:text-[#8B0000]"
              data-testid="hero-cta-menu"
            >
              <Utensils size={20} />
              Vezi meniul
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="scroll-indicator">
        <ChevronDown className="text-white animate-bounce" size={32} />
      </div>
    </section>
  );
};

// Info Cards Section
const InfoCardsSection = () => {
  const cards = [
    {
      icon: <MapPin className="text-[#8B0000]" size={28} />,
      title: "Adresă",
      content: RESTAURANT_DATA.address,
      action: { text: "Indicații", href: RESTAURANT_DATA.mapsUrl, external: true }
    },
    {
      icon: <Clock className="text-[#8B0000]" size={28} />,
      title: "Program",
      content: RESTAURANT_DATA.schedule,
      action: null
    },
    {
      icon: <Utensils className="text-[#8B0000]" size={28} />,
      title: "Servicii",
      content: RESTAURANT_DATA.services.join(" • "),
      action: null
    },
    {
      icon: <Phone className="text-[#8B0000]" size={28} />,
      title: "Telefon",
      content: RESTAURANT_DATA.phone,
      action: { text: "Sună", href: `tel:${RESTAURANT_DATA.phone.replace(/\s/g, '')}`, external: false }
    },
  ];

  return (
    <section className="py-16 bg-white" data-testid="info-cards-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((card, index) => (
            <div
              key={index}
              className="info-card animate-fade-in-up"
              style={{ animationDelay: `${index * 100}ms` }}
              data-testid={`info-card-${index}`}
            >
              <div className="info-card-icon">{card.icon}</div>
              <h3 className="font-semibold text-gray-900 mb-2">{card.title}</h3>
              <p className="text-gray-600 text-sm mb-3">{card.content}</p>
              {card.action && (
                <a
                  href={card.action.href}
                  target={card.action.external ? "_blank" : undefined}
                  rel={card.action.external ? "noopener noreferrer" : undefined}
                  className="inline-flex items-center gap-1 text-[#8B0000] font-medium text-sm hover:underline"
                >
                  {card.action.text}
                  {card.action.external && <ExternalLink size={14} />}
                </a>
              )}
            </div>
          ))}
        </div>

        {/* Action Buttons */}
        <div className="flex flex-wrap justify-center gap-4 mt-10">
          <a
            href={RESTAURANT_DATA.mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-secondary"
            data-testid="btn-directions"
          >
            <Navigation size={18} />
            Indicații de orientare
          </a>
          <a
            href={RESTAURANT_DATA.facebook}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-secondary"
            data-testid="btn-facebook"
          >
            <Facebook size={18} />
            Facebook
          </a>
        </div>
      </div>
    </section>
  );
};

// About Section
const AboutSection = () => {
  const features = [
    "Restaurant modern și curat",
    "Preparate proaspete, gătite impecabil",
    "Servire promptă și amabilă"
  ];

  return (
    <section id="despre" className="py-20 bg-[#FDF8F3] hero-pattern" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="animate-slide-left">
            <div className="relative">
              <img
                src={restaurantImg}
                alt="Interior Grand Gurmand Restaurant"
                className="rounded-2xl shadow-2xl w-full h-[400px] object-cover"
              />
              <div className="absolute -bottom-6 -right-6 bg-[#8B0000] text-white p-6 rounded-2xl shadow-xl">
                <div className="flex items-center gap-2">
                  <Star className="text-[#C9A227] fill-[#C9A227]" size={24} />
                  <span className="text-3xl font-bold">{RESTAURANT_DATA.rating}</span>
                </div>
                <p className="text-sm opacity-80">{RESTAURANT_DATA.reviewsCount} recenzii</p>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="animate-slide-right">
            <div className="decorative-line mb-6" />
            <h2 className="section-title">Despre Noi</h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-8">
              <strong>Grand Gurmand Restaurant</strong> este un restaurant modern cu specific italian, 
              unde gustul autentic se îmbină cu o atmosferă rafinată și o servire impecabilă. 
              Fiecare detaliu – de la preparate până la veselă – este ales pentru a oferi o experiență memorabilă.
            </p>

            {/* Features */}
            <div className="space-y-4">
              {features.map((feature, index) => (
                <div key={index} className="flex items-center gap-4">
                  <div className="feature-check">
                    <Check className="text-white" size={14} />
                  </div>
                  <span className="text-gray-700 font-medium">{feature}</span>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="mt-10">
              <a
                href={`tel:${RESTAURANT_DATA.phone.replace(/\s/g, '')}`}
                className="btn-primary"
                data-testid="about-cta"
              >
                <Phone size={18} />
                Fă o rezervare
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Menu Section
const MenuSection = () => {
  const [activeCategory, setActiveCategory] = useState("Mic Dejun (10:00-12:30)");
  const categories = ["Toate", ...MENU_DATA.categories];

  const filteredItems = activeCategory === "Toate" 
    ? MENU_DATA.items 
    : MENU_DATA.items.filter(item => item.category === activeCategory);

  return (
    <section id="meniu" className="py-20 bg-white" data-testid="menu-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="decorative-line mx-auto mb-6" />
          <h2 className="section-title">Meniul Nostru</h2>
          <p className="section-subtitle">
            Descoperă preparatele noastre autentice italiene, gătite cu ingrediente proaspete și rețete tradiționale.
          </p>
        </div>

        {/* Category Tabs */}
        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`menu-tab ${activeCategory === category ? 'active' : 'text-gray-600'}`}
              data-testid={`menu-tab-${category}`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Menu Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredItems.map((item, index) => (
            <div
              key={item.id}
              className="menu-item-card animate-fade-in"
              style={{ animationDelay: `${index * 50}ms` }}
              data-testid={`menu-item-${item.id}`}
            >
              <div className="flex justify-between items-start mb-2">
                <h3 className="font-display text-lg font-semibold text-gray-900">{item.name}</h3>
                <span className="text-[#8B0000] font-bold whitespace-nowrap ml-4">{item.price}</span>
              </div>
              <p className="text-gray-500 text-sm mb-2">{item.description}</p>
              <div className="flex items-center gap-2">
                <span className="inline-block text-xs text-[#C9A227] font-medium bg-[#C9A227]/10 px-2 py-1 rounded">
                  {item.category}
                </span>
                {item.weight && (
                  <span className="inline-block text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
                    {item.weight}
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Note */}
        <p className="text-center text-gray-500 mt-10 italic">
          {/*'"Meniul complet va fi actualizat în curând."'*/}
        </p>

        {/* CTA */}
        <div className="flex flex-wrap justify-center gap-4 mt-8">
          <a
            href={`tel:${RESTAURANT_DATA.phone.replace(/\s/g, '')}`}
            className="btn-primary"
            data-testid="menu-cta-phone"
          >
            <Phone size={18} />
            Cere meniul pe telefon
          </a>
          <a
            href={RESTAURANT_DATA.facebook}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-secondary"
            data-testid="menu-cta-facebook"
          >
            <Facebook size={18} />
            Facebook
          </a>
        </div>
      </div>
    </section>
  );
};

// Gallery Section
const GallerySection = () => {
  const [activeFilter, setActiveFilter] = useState("Toate");
  const filters = ["Toate", "Meniu", "Mâncăruri & băuturi", "Atmosferă", "Bar"];

  const filteredImages = activeFilter === "Toate"
    ? GALLERY_DATA
    : GALLERY_DATA.filter(img => img.category === activeFilter);

  return (
    <section id="galerie" className="py-20 bg-[#FDF8F3]" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="decorative-line mx-auto mb-6" />
          <h2 className="section-title">Galerie Foto</h2>
          <p className="section-subtitle">
            Explorează atmosfera și preparatele noastre prin imagini.
          </p>
        </div>

        {/* Filters */}
        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {filters.map((filter) => (
            <button
              key={filter}
              onClick={() => setActiveFilter(filter)}
              className={`gallery-filter ${activeFilter === filter ? 'active' : 'bg-white text-gray-600'}`}
              data-testid={`gallery-filter-${filter}`}
            >
              {filter}
            </button>
          ))}
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {filteredImages.map((image, index) => (
            <div
              key={image.id}
              className="gallery-item aspect-square animate-fade-in"
              style={{ animationDelay: `${index * 100}ms` }}
              data-testid={`gallery-item-${image.id}`}
            >
              <img
                src={image.image}
                alt={image.title}
                className="w-full h-full object-cover"
              />
              <div className="gallery-overlay">
                <span className="text-white font-medium">{image.title}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Note */}
        <p className="text-center text-gray-500 mt-10 italic text-sm">

        </p>
      </div>
    </section>
  );
};

// Reviews Section
const ReviewsSection = () => {
  return (
    <section id="recenzii" className="py-20 bg-white" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="decorative-line mx-auto mb-6" />
          <h2 className="section-title">Ce Spun Clienții</h2>
          
          {/* Rating Display */}
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className={`${i < Math.floor(RESTAURANT_DATA.rating) ? 'text-[#C9A227] fill-[#C9A227]' : 'text-gray-300'}`}
                  size={28}
                />
              ))}
            </div>
            <span className="text-3xl font-bold text-gray-900 ml-2">{RESTAURANT_DATA.rating}</span>
          </div>
          <p className="text-gray-500">din {RESTAURANT_DATA.reviewsCount} recenzii</p>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {REVIEWS_DATA.slice(0, 3).map((review, index) => (
            <div
              key={review.id}
              className="review-card animate-fade-in-up"
              style={{ animationDelay: `${index * 150}ms` }}
              data-testid={`review-card-${review.id}`}
            >
              <Quote className="text-[#8B0000]/20 mb-4" size={32} />
              <p className="text-gray-700 mb-6 leading-relaxed">&ldquo;{review.text}&rdquo;</p>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-900">{review.author}</p>
                  <div className="flex mt-1">
                    {[...Array(review.rating)].map((_, i) => (
                      <Star key={i} className="text-[#C9A227] fill-[#C9A227]" size={14} />
                    ))}
                  </div>
                </div>
                <span className="text-sm text-gray-400">
                  {new Date(review.date).toLocaleDateString('ro-RO', { month: 'short', year: 'numeric' })}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Message */}
        <div className="text-center mt-12 p-6 bg-[#FDF8F3] rounded-2xl max-w-2xl mx-auto">
          <p className="text-gray-600 italic">
            {'"Apreciem feedback-ul clienților și ne îmbunătățim constant serviciile."'}
          </p>
        </div>
      </div>
    </section>
  );
};

// Contact Section
const ContactSection = () => {
  return (
    <section id="contact" className="py-20 bg-[#FDF8F3]" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="decorative-line mx-auto mb-6" />
          <h2 className="section-title">Locație & Contact</h2>
          <p className="section-subtitle">
            Vă așteptăm să ne vizitați! Sunați pentru rezervări sau indicații.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-10">
          {/* Map */}
          <div className="map-container h-[400px] lg:h-full min-h-[400px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1350.9479889377772!2d28.82498276911074!3d47.3749486910983!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40cbef0033161c5b%3A0x2e7112255487c36d!2sGrand%20Gurmand%20Restaurant!5e0!3m2!1sro!2s!4v1769812431491!5m2!1sro!2s"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Grand Gurmand Restaurant Location"
            />
          </div>

          {/* Contact Info */}
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h3 className="font-display text-2xl font-semibold text-gray-900 mb-6">
              Informații Contact
            </h3>

            <div className="space-y-6">
              {/* Address */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-[#8B0000]/10 flex items-center justify-center flex-shrink-0">
                  <MapPin className="text-[#8B0000]" size={22} />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Adresă</h4>
                  <p className="text-gray-600">{RESTAURANT_DATA.address}</p>
                  <p className="text-gray-500 text-sm mt-1">Plus code: {RESTAURANT_DATA.plusCode}</p>
                </div>
              </div>

              {/* Phone */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-[#8B0000]/10 flex items-center justify-center flex-shrink-0">
                  <Phone className="text-[#8B0000]" size={22} />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Telefon</h4>
                  <a 
                    href={`tel:${RESTAURANT_DATA.phone.replace(/\s/g, '')}`}
                    className="text-[#8B0000] font-medium hover:underline text-lg"
                  >
                    {RESTAURANT_DATA.phone}
                  </a>
                </div>
              </div>

              {/* Schedule */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-[#8B0000]/10 flex items-center justify-center flex-shrink-0">
                  <Clock className="text-[#8B0000]" size={22} />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Program</h4>
                  <p className="text-gray-600">{RESTAURANT_DATA.schedule}</p>
                </div>
              </div>

              {/* Facebook */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-[#8B0000]/10 flex items-center justify-center flex-shrink-0">
                  <Facebook className="text-[#8B0000]" size={22} />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Facebook</h4>
                  <a 
                    href={RESTAURANT_DATA.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#8B0000] font-medium hover:underline inline-flex items-center gap-1"
                  >
                    Vizitează pagina noastră
                    <ExternalLink size={14} />
                  </a>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 mt-8">
              <a
                href={`tel:${RESTAURANT_DATA.phone.replace(/\s/g, '')}`}
                className="btn-primary justify-center flex-1"
                data-testid="contact-cta-call"
              >
                <Phone size={18} />
                Sună acum
              </a>
              <a
                href={RESTAURANT_DATA.mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-secondary justify-center flex-1"
                data-testid="contact-cta-directions"
              >
                <Navigation size={18} />
                Indicații
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Footer
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1A1A1A] text-white py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div>
            <h3 className="font-display text-2xl font-bold mb-4">Grand Gurmand</h3>
            <p className="text-gray-400 mb-6">
              Restaurant italian modern în Orhei. Gust autentic într-o atmosferă elegantă.
            </p>
            <div className="flex gap-4">
              <a 
                href={RESTAURANT_DATA.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#8B0000] transition-colors"
              >
                <Facebook size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Navigare</h4>
            <ul className="space-y-3">
              {["Acasă", "Despre", "Meniu", "Galerie", "Recenzii", "Contact"].map((link) => (
                <li key={link}>
                  <a 
                    href={`#${link.toLowerCase()}`}
                    className="footer-link hover:text-[#C9A227] transition-colors"
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contact</h4>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="flex-shrink-0 mt-1" />
                <span>{RESTAURANT_DATA.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} />
                <a href={`tel:${RESTAURANT_DATA.phone.replace(/\s/g, '')}`} className="hover:text-white transition-colors">
                  {RESTAURANT_DATA.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Clock size={18} />
                <span>{RESTAURANT_DATA.schedule}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © {currentYear} Grand Gurmand Restaurant. Toate drepturile rezervate.
            </p>
            <div className="flex items-center gap-2 text-gray-500 text-sm">
              <Star className="text-[#C9A227] fill-[#C9A227]" size={14} />
              <span>{RESTAURANT_DATA.rating}/5 din {RESTAURANT_DATA.reviewsCount} recenzii</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

// Main App Component
function App() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [mobileMenuOpen]);

  return (
    <div className="min-h-screen bg-[#FDF8F3]" data-testid="app">
      <Header 
        scrolled={scrolled} 
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
      />
      <main>
        <HeroSection />
        <InfoCardsSection />
        <AboutSection />
        <MenuSection />
        <GallerySection />
        <ReviewsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
